import React from 'react';

import { Grid } from 'core/components/library';

import { Select, DataGridPro as DataGrid, Text } from 'core/components';

import * as hlprs from 'core/helpers';
import * as enums from 'core/enums';

const cols = (name, row, index, editing, handleChange) => [
    {
        key: 'estado',
        title: 'Estado',
        align: 'left',
        //width: '1%',
        component: row && (
            <Select
                fullWidth
                editing={editing}
                name='estado'
                variant='standard'
                margin='none'
                options={enums.statesEntity}
                value={row['estado']}
                onChange={
                    handleChange &&
                    (values => handleChange(values, name, index))
                }
            />
        )
    },
    {
        key: 'motivo',
        title: 'Motivo',
        align: 'left',
        width: '50%',
        component: row && (
            <Text
                fullWidth
                editing={editing}
                name='motivo'
                variant='standard'
                margin='none'
                type='text'
                value={row['motivo']}
                onChange={
                    handleChange &&
                    (values => handleChange(values, name, index))
                }
            />
        )
    },
    {
        key: 'desde',
        title: 'Desde',
        align: 'left',
        //width: '1%',
        component: row && (
            <Text
                fullWidth
                editing={editing}
                name='desde'
                variant='standard'
                margin='none'
                type='date'
                value={row['desde']}
                onChange={
                    handleChange &&
                    (values => handleChange(values, name, index))
                }
            />
        )
    },
    {
        key: 'hasta',
        title: 'Hasta',
        align: 'left',
        //width: '1%',
        component: row && (
            <Text
                fullWidth
                editing={editing}
                name='hasta'
                variant='standard'
                margin='none'
                type='date'
                value={row['hasta']}
                onChange={
                    handleChange &&
                    (values => handleChange(values, name, index))
                }
            />
        )
    }
];

const Estado = props => {
    const { values, editing, adding, handleChange, refresh } = props;

    return (
        <Grid container spacing={1}>
            <Grid item xs>
                <DataGrid
                    name='estados'
                    editing={editing}
                    rows={values.estados ? values.estados : []}
                    cols={(name, row, index) =>
                        cols(name, row, index, editing, handleChange)
                    }
                    onAdd={name => handleChange({ desde: hlprs.toDay() }, name)}
                    onDelete={(name, index) =>
                        handleChange(undefined, name, (index + 1) * -1)
                    }
                    maxHeight={456}
                />
            </Grid>
        </Grid>
    );
};

export default Estado;
